import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getUsersAllocatableToProject = api(
    ({ projectId, searchTerm = "", skip = 0, take = 20, orderStmt = ["displayName"] } = {}) =>
        query(
            gql`
                query GetUsersAllocatableToProject($projectId: String!, $searchTerm: String, $skip: Int, $take: Int) {
                    getUsersAllocatableToProject(
                        projectId: $projectId
                        searchTerm: $searchTerm
                        skip: $skip
                        take: $take
                    ) {
                        users {
                            id
                            UserName
                            UserId
                            client
                            metadata
                        }
                        total
                    }
                }
            `,
            { projectId, searchTerm, skip, take, orderStmt },
            { returns: "getUsersAllocatableToProject", fetchPolicy: "network-only" }
        )
)
